import React, { useState } from "react";
import { FiChevronDown } from "react-icons/fi";

const ExpandSection = ({ product }) => {
  const extraInfo = [
    'Hassle-free returns within 7 days; specific conditions apply based on products and promotions.',
    'Prepaid order refunds are processed to the original payment method;',
    'COD orders receive a coupon code refund.',
    'Issues with defective, incorrect, or damaged products must be reported within 24 hours of delivery.',
    'A reverse shipment fee of Rs 100 is charged, which will be deducted from the refund.'
  ];
  
  const [expanded1, setExpanded1] = useState(false);
  const [expanded2, setExpanded2] = useState(false);
  const [expanded3, setExpanded3] = useState(false);

  const toggleExpand1 = () => {
    setExpanded1(!expanded1);
  };

  const toggleExpand2 = () => {
    setExpanded2(!expanded2);
  };

  const toggleExpand3 = () => {
    setExpanded3(!expanded3);
  };

  return (
    <div className="font-twentieth-century">
      <div
        className={`border border-gray-300 p-2 cursor-pointer ${
          expanded1 ? "h-auto" : "h-12 overflow-hidden" // Adjust height and overflow classes
        }`}
        onClick={toggleExpand1} // Ensure toggleExpand function is defined and correctly toggles expanded state
      >
        <div className="flex flex-col">
          <div className="flex justify-between text-gray-600">
            <p className="mt-1 text-left tracking-widest">DESCRIPTION</p>
            <FiChevronDown className="text-2xl mt-1" />
          </div>

          {expanded1 && (
            <div className="text-gray-700">
              <p className="mt-2 ml-3 text-left">{product.description}</p>
            </div>
          )}
        </div>
      </div>
      <div
        className={`border border-gray-300 p-2 cursor-pointer ${
          expanded2 ? "h-auto" : "h-12 overflow-hidden" // Adjust height and overflow classes
        }`}
        onClick={toggleExpand2} // Ensure toggleExpand function is defined and correctly toggles expanded state
      >
        <div className="flex flex-col">
          <div className="flex justify-between text-gray-600">
            <p className="mt-1 text-left tracking-widest">
              PRODUCT SPECIFICATION
            </p>
            <FiChevronDown className="text-2xl mt-1" />
          </div>

          {expanded2 && (
            <ul className="list-disc ml-5 text-gray-700">
              {product.prodSpec.map((spec, index) => (
                <li key={index} className="mt-2 ml-3 text-left">
                  {spec}
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
      <div
        className={`border border-gray-300 p-2 cursor-pointer ${
          expanded3 ? "h-auto" : "h-12 overflow-hidden" // Adjust height and overflow classes
        }`}
        onClick={toggleExpand3} // Ensure toggleExpand function is defined and correctly toggles expanded state
      >
        <div className="flex flex-col">
          <div className="flex justify-between text-gray-600">
            <p className="mt-1 text-left tracking-widest">
              RETURNS & EXCHANGE INFORMATION
            </p>
            <FiChevronDown className="text-2xl mt-1" />
          </div>

          {expanded3 && (
            <ol className="list-decimal ml-5 text-gray-700">
              {extraInfo.map((spec, index) => (
                <li key={index} className="mt-2 ml-3 text-left">
                  {spec}
                </li>
              ))}
            </ol>
          )}
        </div>
      </div>
    </div>
  );
};

export default ExpandSection;
